export default __webpack_public_path__ + "images/722ed9dc2a16c9efd57aa18e43684438.svg";